var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCancionesBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B2B2B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M96.9,49L96.9,49c-0.4-0.4-0.9-0.6-1.5-0.5l-33.7,4.4C60.7,53,60,53.9,60,54.8v36.7c-2.1-1.8-4.9-2.8-7.8-2.8 c-6.4,0-11.7,4.8-11.7,10.6c0,5.9,5.2,10.6,11.7,10.6s11.7-4.8,11.7-10.6c0-0.2,0-0.5,0-0.7c0-0.1,0-0.2,0-0.3V67.6l29.9-3.8v16.9 c-2.1-1.8-4.9-2.8-7.8-2.8c-6.4,0-11.7,4.8-11.7,10.6S79.4,99.1,86,99.1c6.3,0,11.6-4.7,11.7-10.3V50.4C97.5,49.9,97.3,49.4,96.9,49 z M93.7,88.5c0,3.7-3.5,6.8-7.8,6.8c-4.4,0-7.8-3.1-7.8-6.8s3.5-6.8,7.8-6.8C90.2,81.7,93.7,84.8,93.7,88.5z M93.7,52.6v7.3 l-29.9,3.8v-7.3L93.7,52.6z M60,99.4c0,3.7-3.5,6.8-7.8,6.8c-4.4,0-7.8-3.1-7.8-6.8s3.5-6.8,7.8-6.8S60,95.7,60,99.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCancionesBlack);
export default __webpack_public_path__ + "static/media/icono-canciones-black.c2283e1dd98937606af2cc954c5d8389.svg";
export { ForwardRef as ReactComponent };